import React from 'react'
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'
import { NavLink } from 'react-router-dom'




const Logo = styled.h1`
display: inline-block;
color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
font-family: 'Pacifico',cursive;

position: fixed;
left: 2rem;
top: 2rem;
z-index:3;
cursor: pointer;

@media (max-width: 768px) {
    font-size: 25px;
    left: 1.2rem
  }
`

const LogoComponent = (props) => {
  return (
    <NavLink to="/"><Logo color={props.theme}>
      Shree
    </Logo>
    </NavLink>
  )
}

export default LogoComponent
